import React, { useEffect, useRef, useState } from "react";

interface ActionsMenuProps {
  canMassSign: boolean;
  canUnlock: boolean;
  hasSelection: boolean;
  busy: boolean;
  onMassSignSelected: () => void;
  onMassSignAll: () => void;
  onUnlockSelected: () => void;
}

export default function ActionsMenu(props: ActionsMenuProps) {
  const {
    canMassSign,
    canUnlock,
    hasSelection,
    busy,
    onMassSignSelected,
    onMassSignAll,
    onUnlockSelected
  } = props;

  const [open, setOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const onOutsideClick = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", onOutsideClick);
    return () => document.removeEventListener("mousedown", onOutsideClick);
  }, []);

  if (!canMassSign && !canUnlock) {
    return null;
  }

  const disableSelectedActions = !hasSelection || busy;

  return (
    <div className="btn-group monitor-react-patient-actions" role="group" aria-label="Monitor patient actions" ref={menuRef}>
      <button
        className="btn btn-secondary dropdown-toggle"
        type="button"
        id="monitorReactPatientsButton"
        aria-haspopup="menu"
        aria-expanded={open ? "true" : "false"}
        onClick={() => setOpen((value) => !value)}
      >
        Patients
      </button>
      <div className={`dropdown-menu dropdown-menu-right monitor-react-action-menu ${open ? "show" : ""}`} aria-labelledby="monitorReactPatientsButton">
        {canMassSign && (
          <>
            <button
              type="button"
              className="dropdown-item"
              onClick={() => {
                if (!disableSelectedActions) {
                  onMassSignSelected();
                }
                setOpen(false);
              }}
              disabled={disableSelectedActions}
            >
              Acknowledge Selected Stable Patient(s)
            </button>
            <button
              type="button"
              className="dropdown-item"
              onClick={() => {
                if (!busy) {
                  onMassSignAll();
                }
                setOpen(false);
              }}
              disabled={busy}
            >
              Acknowledge ALL Stable Patients
            </button>
          </>
        )}
        {canUnlock && (
          <button
            type="button"
            className="dropdown-item"
            onClick={() => {
              if (!disableSelectedActions) {
                onUnlockSelected();
              }
              setOpen(false);
            }}
            disabled={disableSelectedActions}
          >
            Override Lock
          </button>
        )}
      </div>
    </div>
  );
}
